<template>
  <div class="phone-call-button">
    <button
      @click="recordCall"
      class="button is-small phone-btn"
      :class="{ 'is-loading': isLoading }"
      :title="'רשום שיחה למעסיק'"
    >
      <span class="icon">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
          <path d="M6.62,10.79C8.06,13.62 10.38,15.94 13.21,17.38L15.41,15.18C15.69,14.9 16.08,14.82 16.43,14.93C17.55,15.3 18.75,15.5 20,15.5A1,1 0 0,1 21,16.5V20A1,1 0 0,1 20,21A17,17 0 0,1 3,4A1,1 0 0,1 4,3H7.5A1,1 0 0,1 8.5,4C8.5,5.25 8.7,6.45 9.07,7.57C9.18,7.92 9.1,8.31 8.82,8.59L6.62,10.79Z"/>
        </svg>
      </span>
      <span v-if="callCount > 0" class="call-counter">{{ callCount }}</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'PhoneCallButton',
  props: {
    companyId: {
      type: [String, Number],
      required: false
    },
    positionId: {
      type: [String, Number],
      required: false
    },
    data: {
      type: Object,
      required: false
    },
    payload: {
      type: Object,
      required: false
    },
    additional_data: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      isLoading: false,
      callCount: 0
    }
  },
  computed: {
    actualCompanyId () {
      // Direct companyId prop
      if (this.companyId) {
        return this.companyId
      }

      // From payload prop (used in CompanyAlertsForm)
      if (this.payload && this.payload.resource_id) {
        return this.payload.resource_id
      }

      // From data prop with nested structure
      if (this.data && this.data.position && this.data.position.company && this.data.position.company.id) {
        return this.data.position.company.id
      }

      // From data prop with direct resource_id
      if (this.data && this.data.resource_id) {
        return this.data.resource_id
      }

      // From data prop with direct id
      if (this.data && this.data.id) {
        return this.data.id
      }

      return null
    },
    actualPositionId () {
      return this.positionId || (this.data && this.data.position_id)
    }
  },
  created () {
    this.loadTodayCallCount()
  },
  methods: {
    async recordCall () {
      if (this.isLoading) return

      // Validate that we have a company ID
      if (!this.actualCompanyId) {
        console.error('Cannot record call: No company ID found', {
          companyId: this.companyId,
          payload: this.payload,
          data: this.data
        })
        this.$utils.emit('show_toast', {
          text: 'שגיאה: לא נמצא מזהה חברה',
          type: 'error'
        })
        return
      }

      this.isLoading = true

      try {
        const statData = {
          designator: 'employer_phone_call',
          priority: 5,
          resource_type: 'Company',
          resource_id: this.actualCompanyId,
          owner: this.$utils.getOwner().name,
          title: 'שיחה למעסיק',
          content: `שיחה טלפונית למעסיק - ${new Date().toLocaleString('he-IL')}`,
          created_by: 'Admin'
        }

        if (this.actualPositionId) {
          statData.additional_data = { position_id: this.actualPositionId }
        }

        console.log('Posting stat with data:', statData)
        await this.$network_utils.postStat(statData)

        this.callCount++
        this.$utils.emit('show_toast', { text: 'שיחה נרשמה בהצלחה' })

        // Emit event for parent components to update their counters
        this.$emit('call-recorded', {
          companyId: this.actualCompanyId,
          positionId: this.actualPositionId,
          count: this.callCount
        })
      } catch (error) {
        console.error('Error recording call:', error)
        this.$utils.emit('show_toast', {
          text: 'שגיאה ברישום השיחה',
          type: 'error'
        })
      } finally {
        this.isLoading = false
      }
    },

    async loadTodayCallCount () {
      try {
        const today = new Date()
        const startOfDay = new Date(today.getFullYear(), today.getMonth(), today.getDate())
        const endOfDay = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1)

        const count = await this.$network_utils.getStats({
          resource_type: 'Company',
          resource_id: this.actualCompanyId,
          designator: 'employer_phone_call',
          owner: this.$utils.getOwner().name,
          date_from: startOfDay.toISOString(),
          date_to: endOfDay.toISOString(),
          count_only: true
        })

        this.callCount = count || 0
      } catch (error) {
        console.error('Error loading call count:', error)
        this.callCount = 0
      }
    }
  }
}
</script>

<style scoped>
.phone-call-button {
  display: inline-block;
  position: relative;
}

.phone-btn {
  background-color: #3273dc !important;
  color: white !important;
  border: none !important;
  border-radius: 4px;
  position: relative;
  transition: all 0.2s ease;
}

.phone-btn:hover {
  background-color: #2366d1 !important;
  transform: scale(1.05);
}

.phone-btn:active {
  transform: scale(0.95);
}

.phone-btn .icon {
  margin-right: 0 !important;
}

.call-counter {
  position: absolute;
  top: -8px;
  right: -8px;
  background-color: #ff3860;
  color: white;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  font-size: 10px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  min-width: 18px;
  padding: 0 2px;
}

.call-counter:empty {
  display: none;
}
</style>
